import TryDemoPage from './TryDemoPage';

export default TryDemoPage;
